import styles from "./departments.module.scss";
import storeStyles from "../stores/stores-page/store-page/store-page.module.scss";
import cl from "classnames";
import { observer } from "mobx-react-lite";
import { ImagePortrait, Input, RatingStars } from "@touche-lts/panel-ui/dist";
import { useRootStore } from "mobx-stores/store-provider";
import { useEffect, useState } from "react";
import { Department, DepartmentCategory } from "models/departments";
import AvatarEditor from "react-avatar-editor";
import { useParams } from "react-router";
import { PageContainer } from "../../components";

const DepartmentPageComponent = () => {
  const defaultImageSrc =
      "https://st2.depositphotos.com/4403291/7418/v/600/depositphotos_74189661-stock-illustration-online-shop-log.jpg",
    {
      storesPublic: { getAllStores, onSearchStore, pageStores },
      departmentsStore: { allDepartments, getAllCategories, allCategories },
      routingStore: { push },
    } = useRootStore(),
    [searchStore, setSearchStore] = useState<string>(""),
    searchHandle = (search: string) => {
      setSearchStore(search);
      onSearchStore(search);
    },
    handleCategoryCover = (): Department => {
      return allDepartments.find(
        (department: Department) => department?.id === Number(departmentId),
      );
    },
    { departmentId } = useParams<{ departmentId: string }>();

  useEffect(() => {
    getAllStores({ resetPageNumber: true });
    if (departmentId) {
      getAllCategories(Number(departmentId));
    }
  }, [getAllCategories, getAllStores, departmentId]);

  return (
    <PageContainer
      className={cl(styles.scrollable, styles.departmentsContainer)}
    >
      {!departmentId ? (
        <div className={styles.storesBackground}>
          <div className="container">
            <p className="pl-3">All Departments</p>
          </div>
        </div>
      ) : (
        <div className={styles.departmentCoverImage}>
          <AvatarEditor
            image={handleCategoryCover()?.backgroundCrop?.url}
            width={1200}
            height={263}
            border={0}
            scale={handleCategoryCover()?.backgroundCrop?.squareWidth}
            position={{
              x: handleCategoryCover()?.backgroundCrop?.squareX,
              y: handleCategoryCover()?.backgroundCrop?.squareY,
            }}
            rotate={0}
          />
          <p>{handleCategoryCover()?.name}</p>
        </div>
      )}
      <div className={styles.storePageContainer}>
        <Input
          colorPreset="dark"
          placeholder="Search for a store..."
          value={searchStore}
          onChange={(search) => searchHandle(search)}
        />
        {!searchStore.length ? (
          <>
            {!departmentId ? (
              <div className={styles.departmentContainerImage}>
                {allDepartments?.map((department: Department) => {
                  return (
                    <div onClick={() => push("/departments/" + department?.id)}>
                      <AvatarEditor
                        image={department?.squareCrop?.url}
                        width={256}
                        height={256}
                        border={0}
                        scale={department?.squareCrop?.squareWidth}
                        position={{
                          x: department?.squareCrop?.squareX,
                          y: department?.squareCrop?.squareY,
                        }}
                        rotate={0}
                        className={styles.departmentImage}
                      />
                      <span>{department?.name}</span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className={styles.departmentContainerImage}>
                {allCategories?.map((category: DepartmentCategory) => {
                  return (
                    <div
                      onClick={() =>
                        push(
                          `/departments/${departmentId}/category/${category?.id}`,
                        )
                      }
                    >
                      <AvatarEditor
                        image={category?.squareCrop?.url}
                        width={256}
                        height={256}
                        border={0}
                        scale={category?.squareCrop?.squareWidth}
                        position={{
                          x: category?.squareCrop?.squareX,
                          y: category?.squareCrop?.squareY,
                        }}
                        rotate={0}
                        className={styles.departmentImage}
                      />
                      <span>{category?.name}</span>
                    </div>
                  );
                })}
                {!allCategories.length && (
                  <p>No categories available for the selected department!</p>
                )}
              </div>
            )}
          </>
        ) : (
          <div className={storeStyles.storesContainer}>
            {pageStores?.content?.map((product) => {
              // TODO-A To add model type
              return (
                <div
                  className={storeStyles.productInfo}
                  onClick={() => push(`/product/${product.id}`)}
                >
                  <div className={storeStyles.productInfoDetails}>
                    <ImagePortrait
                      width={176}
                      height={176}
                      src={
                        !!product?.image ? product?.image?.url : defaultImageSrc
                      }
                    />
                    <div className={storeStyles.productInfoDetailsText}>
                      <h2>{product.name}</h2>
                      <RatingStars
                        rating={product?.rating}
                        reviewsCnt={product?.reviewsCnt}
                      />
                      <small>Add to cart</small>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </PageContainer>
  );
};

const DepartmentPage = observer(DepartmentPageComponent);
export { DepartmentPage };
